import React, { useEffect } from "react"
import { Col, Row } from "react-bootstrap"

import { selectValueFromId } from "../../utils/format-skills-for-select"
import ReturnIdIfExists from "../../utils/return-id-if-exists"
import TagInput from "../input/tag-input"

const LocationFilter = ({
  showLocation,
  config,
  handleCountryChange,
  handleProvinceChange,
  search,
  province,
  provinceList,
  city,
  cityList,
  setCityList,
  handleCityChange,
  setShowLocation,
  UpArrow,
}) => {
  useEffect(() => {
    const cityData = ReturnIdIfExists(provinceList, search.state)
    if (cityData && cityData.districts) {
      setCityList(cityData.districts)
    }
  }, [provinceList, cityList]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Col lg={12} className="mb-2">
      <Row className="align-items-center">
        <Col xs={10} className="mb-2">
          <h5>Location</h5>
        </Col>
        <Col xs={2} className="text-right mb-2">
          <button
            className="no-outline no-border no-background p-0"
            onClick={() => setShowLocation(!showLocation)}
          >
            <img
              src={UpArrow}
              alt="wdn-arrow"
              className={!showLocation ? "up" : "down"}
            />
          </button>
        </Col>
        {showLocation && (
          <>
            <Col lg={12}>
              <TagInput
                name="country"
                styles={` outline-faded`}
                error={""}
                options={config.country}
                value={selectValueFromId(config?.country, search?.country)}
                onFocus={() => {}}
                label={""}
                placeholder={"Type and Select..."}
                useOnChange={handleCountryChange}
                closeMenuOnSelect
                disabled
              />
            </Col>

            <Col lg={12}>
              <TagInput
                name="state"
                styles={` outline-faded`}
                error={""}
                options={provinceList}
                value={selectValueFromId(provinceList, province)}
                onFocus={() => {}}
                disabled={provinceList.length === 0}
                label={""}
                placeholder={"State"}
                useOnChange={handleProvinceChange}
                closeMenuOnSelect
                isClearable={false}
              />
            </Col>
            <Col lg={12}>
              <TagInput
                name="city"
                styles={` outline-faded`}
                error={""}
                options={cityList}
                value={selectValueFromId(
                  cityList,
                  !!city ? city : search.location
                )}
                onFocus={() => {}}
                label={""}
                placeholder={"City"}
                useOnChange={handleCityChange}
                closeMenuOnSelect
                disabled={province === 0}
                isClearable={false}
              />
            </Col>
          </>
        )}
      </Row>
      <div className="border-bottom mb-2"></div>
    </Col>
  )
}

export default LocationFilter
